module.exports = __webpack_public_path__ + "static/media/se_page12.b75bebf0.ogg";